// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dottler: PokeData = {
  "id": 825,
  "name": "dottler",
  "height": 4,
  "weight": 195,
  "base_experience": 117,
  "types": [
    PokeType.BUG,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "confusion",
    "light-screen",
    "reflect",
    "struggle-bug"
  ],
  "moves": [
    "reflect",
    "psy-ball",
    "pounce",
    "prismatic-cage",
    "kinesis",
    "pin-missile",
    "zen-headbutt",
    "signal-spam",
    "infest",
    "sticky-web",
    "future-sight",
    "synchronize",
    "pin-rush"
  ],
  "evolution_chain": {
    "id": 435,
    "item": null,
    "species": [
      {
        "name": "blipbug",
        "order": 824,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dottler",
        "order": 825,
        "types": [
          PokeType.BUG,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 824,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 10,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "orbeetle",
        "order": 826,
        "types": [
          PokeType.BUG,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 825,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 67.5,
    "speed": 30,
    "ability_power": 50
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
